import {CanMatchFn, UrlSegment} from '@angular/router';
import {SlugEntity, SUBJECT_SLUGS} from '@entities/router/slug-types';

export const isSubjectSlugGuard: CanMatchFn = (
  _route,
  segments: UrlSegment[]
) => SUBJECT_SLUGS.includes(segments[0]?.path as SlugEntity);
